import { render, staticRenderFns } from "./CountrySummary.vue?vue&type=template&id=f5d2f50a&scoped=true"
import script from "./CountrySummary.vue?vue&type=script&lang=js"
export * from "./CountrySummary.vue?vue&type=script&lang=js"
import style0 from "./CountrySummary.vue?vue&type=style&index=0&id=f5d2f50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d2f50a",
  null
  
)

export default component.exports